import Button from "@components/Button";
import CustomInput, { CustomSelectInput } from "@components/CustomInput/CustomInput";
import {React, useState} from "react";
import styles from "./TicketUpdateComponent.module.css";
import ArrowRightAltIcon from '@mui/icons-material/ArrowRightAlt';
import useTicket from "@hooks/useTicket";

const TicketUpdateComponent = ({user, type, setUpdate, refreshTickets}) => {
    const [comment, setComment] = useState("");
    const [currentStatus, setCurrentStatus] = useState("");
    const {handleUpdateSupportTicket} = useTicket();
    const handleComponentDisplay = () => {
        setUpdate(false);
    };

    const handleUpdateTicket = (comment,currentStatus) => {
        const updatedData = {
            type: type,
            _id: user._id,
            comment: comment,
            to: currentStatus,
        };
        const from = user.currentStage;
        handleUpdateSupportTicket(updatedData);
        handleComponentDisplay();
    }

    const handleUpdate = () => {
        if(!currentStatus || !comment){
            alert("Please select a status and comment");
            return;
        }
        else {
            handleUpdateTicket(comment, currentStatus);
            refreshTickets((prev) => !prev);
            return;
        }
    }

    const statusOptions = [
        { value: "open", option: "Open" },
        { value: "acknowledged", option: "Acknowledged" },
        { value: "inprogress", option: "In Progress" },
        { value: "awaiting", option: "Awaiting" },
        { value: "resolved", option: "Resolved" },
        { value: "hold", option: "Hold" },
    ];

    return (
    <div className={styles.card}>
        <div className={styles.cardHead}>
            <p><strong>Id:</strong>{user.id}</p>
            <p><strong>User:</strong>{user.userType}</p>
        </div>
        <div className={styles.updateBar}>
            <div>
                <p><strong>Current Status</strong></p>
                <p>{user.currentStage}</p>
            </div>
            <ArrowRightAltIcon sx={{width:"8rem", height:"8rem"}}/>
            <div>
                <p><strong>New Status</strong></p>
                <CustomSelectInput
                    className={styles.CustomSelect}
                    selectOptions={statusOptions}
                    defaultOption="select"
                    value={currentStatus}
                    onChange={(event) => setCurrentStatus(event.target.value)}
                    name="status"
                />
            </div>
        </div>
        <CustomInput 
            align={"left"} 
            className={styles.Input}
            placeholder="Enter comment" 
            showSearchIcon 
            name="comment" 
            value={comment} 
            onChange={(e) => setComment(e.target.value)} 
        />
        <div className={styles.ButtonGroup}>
            <Button 
                onClick={handleUpdate} 
                className={styles.Button}
                text="Update"
                btnType="primary"
            />
            <Button 
                onClick={handleComponentDisplay} 
                className={styles.Button}
                text="Close"
                btnType="primary"
            />
        </div>
    </div>
    );
};

export default TicketUpdateComponent;